import { __assign, __makeTemplateObject } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { N200, N900 } from '@atlaskit/theme/colors';
import Lozenge from '@atlaskit/lozenge';
var Wrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  line-height: 1;\n  outline: none;\n  margin: 0;\n  width: 100%;\n  cursor: pointer;\n"], ["\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  line-height: 1;\n  outline: none;\n  margin: 0;\n  width: 100%;\n  cursor: pointer;\n"])));
var Text = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0;\n  color: ", ";\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ", "\n"], ["\n  margin: 0;\n  color: ", ";\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ",
    "\n"])), N900, function (_a) {
    var secondary = _a.secondary;
    return secondary &&
        "\n        color: " + N200 + ";\n        font-size: 0.85em;\n      ";
});
export var TextWrapper = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline-block;\n"], ["\n  color: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline-block;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
export var AvatarItemOption = function (_a) {
    var avatar = _a.avatar, primaryText = _a.primaryText, secondaryText = _a.secondaryText, lozenge = _a.lozenge;
    return (React.createElement(Wrapper, null,
        avatar,
        React.createElement("div", { style: {
                maxWidth: '100%',
                minWidth: 0,
                flex: '1 1 100%',
                lineHeight: '1.4',
                paddingLeft: '8px',
            } },
            React.createElement("div", null,
                React.createElement(Text, null, primaryText),
                React.createElement("span", { style: {
                        float: 'right',
                    } }, lozenge && React.createElement(Lozenge, __assign({}, lozenge), lozenge.text))),
            React.createElement("div", null,
                React.createElement(Text, { secondary: true }, secondaryText)))));
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=AvatarItemOption.js.map